export function getMeasuredFirstRowItemCount({
  firstRowCount,
  totalItemCount,
}: {
  firstRowCount: number;
  totalItemCount: number;
}) {
  if (firstRowCount <= 0) {
    return 0;
  }

  const allItemsFitOnFirstRow = firstRowCount >= totalItemCount;

  if (allItemsFitOnFirstRow) {
    return firstRowCount;
  }

  return Math.max(firstRowCount - 1, 0);
}
